import { useEffect, useState, memo } from "react";
import axios from "axios";
import { HiUserAdd } from "react-icons/hi";
import { UseAllState } from "../Context";
import { toast } from "react-hot-toast";
import { Navigate, useNavigate } from "react-router-dom";
import backarrow from "../assets/icon/arrow-right.svg";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { motion } from "framer-motion";
import {
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
} from "react-icons/fa";

// پس زمینه متحرک
const icons = [
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
];

const staticBackgroundIcons = (() => {
  const rows = 5,
    cols = 11,
    arr = [];
  for (let i = 0; i < rows; i++)
    for (let j = 0; j < cols; j++) {
      const Icon = icons[Math.floor(Math.random() * icons.length)];
      arr.push({
        Icon,
        size: 18 + Math.random() * 20,
        top: (i / rows) * 100 + Math.random() * 5,
        left: (j / cols) * 100 + Math.random() * 5,
        duration: 12 + Math.random() * 10,
        opacity: 0.15 + Math.random() * 0.25,
        xOffset: Math.random() * 10 - 5,
        yOffset: Math.random() * 10 - 5,
      });
    }
  return arr;
})();

const AnimatedBackground = memo(() => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    {staticBackgroundIcons.map((item, i) => (
      <motion.div
        key={i}
        className="absolute text-white/50"
        style={{
          top: `${item.top}%`,
          left: `${item.left}%`,
          opacity: item.opacity,
        }}
        initial={{ scale: 0.5 }}
        animate={{
          x: [0, item.xOffset, 0],
          y: [0, item.yOffset, 0],
          scale: [0.5, 1, 0.5],
        }}
        transition={{
          duration: item.duration,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <item.Icon size={item.size} />
      </motion.div>
    ))}
  </div>
));

const EditProfile = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [uploadimage, setUploadimage] = useState("");
  const [apiimage, setApiimage] = useState(true);
  const [showuploadicon, setShowuploadicon] = useState(true);
  const [imageid, setImageid] = useState("");
  const { image, setImage, setLastName, setFirstName } = UseAllState();
  const [initialEmail, setInitialEmail] = useState("");
  const [changepassword, setChangepassword] = useState(false);
  const [previousPassword, setPreviousPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPrevPass, setShowPrevPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const API_BASE = process.env.REACT_APP_API_URL;

  const [savingAnim, setSavingAnim] = useState(false);

  const handlechooseimage = () => document.getElementById("openimage")?.click();

  const handleuploadimage = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setShowuploadicon(false);
    const formdata = new FormData();
    formdata.append("file", file);

    axios
      .post(`${API_BASE}/api/files/admin/upload-file`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        toast.success("تصویر با موفقیت آپلود شد");
        setImageid(res.data.data.fileId);
        setApiimage(false);
        setUploadimage(URL.createObjectURL(file));
      })
      .catch(() => toast.error("خطا در آپلود تصویر"));
  };

  const handleEditprof = () => {
    // شروع انیمیشن دکمه ها
    setSavingAnim(true);
    setTimeout(() => setSavingAnim(false), 600);
    //

    const payload = { email };
    const emailChanged = email !== initialEmail;
    if (uploadimage) payload.imageid = imageid;
    if (previousPassword.trim()) payload.previousPassword = previousPassword;
    if (newPassword.trim()) payload.newPassword = newPassword;

    axios
      .post(`${API_BASE}/api/admin/Update-My-Profile`, payload, {
        headers: { Authorization: localStorage.getItem("token") },
      })
      .then((res) => {
        toast.success(res.data.message);
        if (emailChanged || newPassword.trim()) {
          localStorage.clear();
          navigate("/");
        } else {
          fetchProfile();
        }
      })
      .catch((error) =>
        toast.error(error?.response?.data?.message || "خطای ناشناخته!")
      );
  };

  const fetchProfile = () => {
    axios
      .get(`${API_BASE}/api/admin/Get-My-Profile`, {
        headers: { Authorization: localStorage.getItem("token") },
      })
      .then((res) => {
        setEmail(res.data.data.admin.email || "");
        setInitialEmail(res.data.data.admin.email || "");
        setFirstName(res.data.data.admin.firstName || "");
        setLastName(res.data.data.admin.lastName || "");
        if (res.data.data.profile) {
          setImage(res.data.data.profile.fileName || "");
          setShowuploadicon(false);
        }
      })
      .catch(() => toast.error("خطا در دریافت اطلاعات"));
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  if (!localStorage.getItem("token")) return <Navigate to="/" />;

  return (
    <div className="relative min-h-screen w-full bg-gray-800 flex items-center justify-center p-4">
      <AnimatedBackground />

      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl p-5 w-full max-w-md mx-auto border border-white/30"
      >
        <h2 className="text-xl font-bold text-gray-800 text-center mb-5">
          ویرایش اطلاعات فردی
        </h2>

        {changepassword ? (
          <div className="space-y-4">
            <img
              src={backarrow}
              alt="back"
              className="cursor-pointer w-8 mr-2"
              onClick={() => {
                setChangepassword(false);
                setPreviousPassword("");
                setNewPassword("");
              }}
            />
            <InputPassword
              value={previousPassword}
              setValue={setPreviousPassword}
              placeholder="رمز عبور فعلی"
              show={showPrevPass}
              setShow={setShowPrevPass}
            />
            <InputPassword
              value={newPassword}
              setValue={setNewPassword}
              placeholder="رمز عبور جدید"
              show={showNewPass}
              setShow={setShowNewPass}
            />
          </div>
        ) : (
          <>
            <div className="flex justify-center mb-6">
              <div
                onClick={handlechooseimage}
                className="relative w-24 h-24 rounded-full border-[3px] border-gray-700 overflow-hidden cursor-pointer shadow-xl hover:scale-105 transition"
              >
                <input
                  type="file"
                  id="openimage"
                  accept="image/*"
                  className="hidden"
                  onChange={handleuploadimage}
                />
                {showuploadicon ? (
                  <div className="w-full h-full flex items-center justify-center bg-gray-100">
                    <HiUserAdd size={48} className="text-gray-600" />
                  </div>
                ) : apiimage ? (
                  <img
                    src={`${API_BASE}/${image}`}
                    alt="profile"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <img
                    src={uploadimage}
                    alt="uploaded"
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
            </div>

            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ایمیل"
              autoComplete="off"
              style={{ color: "#4b5563" }}
              className="w-full px-4 py-3.5 rounded-xl border-2 border-gray-400 focus:border-gray-700 outline-none font-semibold bg-white/70 transition placeholder-gray-400 text-sm"
            />

            <button
              onClick={() => setChangepassword(true)}
              className="w-full mt-4 py-3.5 border-2 border-gray-700 text-gray-800 font-bold rounded-xl hover:bg-gray-100 transition text-sm"
            >
              تغییر رمز عبور
            </button>
          </>
        )}

        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.98 }}
          onClick={handleEditprof}
          className="w-full mt-6 py-4 bg-gray-800 hover:bg-gray-900 text-white font-semibold rounded-xl shadow-xl transition text-base"
        >
          ذخیره تغییرات
        </motion.button>
      </motion.div>
    </div>
  );
};

const InputPassword = ({ value, setValue, placeholder, show, setShow }) => (
  <div className="w-full px-4 py-3.5 bg-white/70 rounded-xl border-2 border-gray-400 focus-within:border-gray-700 shadow-sm flex items-center justify-between">
    <input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      type={show ? "text" : "password"}
      placeholder={placeholder}
      className="bg-transparent flex-1 outline-none font-semibold text-gray-800 text-sm"
    />
    <button onClick={() => setShow(!show)} className="p-1.5">
      {show ? (
        <AiOutlineEyeInvisible size={20} className="text-gray-600" />
      ) : (
        <AiOutlineEye size={20} className="text-gray-600" />
      )}
    </button>
  </div>
);

export default EditProfile;
